import React, { FC } from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/yoshi-flow-editor/tpa-settings/react';

import { classes, st } from './Header.st.css';
import { SectionHeader } from '../common/SectionHeader';
import { CTAGroup } from '../common/CTAGroup';
import settingsParams from '../../settingsParams';

export const Header: FC = () => {
  const settings = useSettings();
  const { isMobile } = useEnvironment();

  return (
    <div className={st(classes.root, { mobile: isMobile })}>
      <div>
        <SectionHeader
          title={settings.get(settingsParams.pageSectionTitle)}
          subtitle={settings.get(settingsParams.pageSectionSubtitle)}
        />
      </div>
      <div>
        <CTAGroup />
      </div>
    </div>
  );
};
